// src/pages/Home/index.js
import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { HomeHeader } from '../../components/layout/Header';
import ServiceCategory from '../../components/ui/ServiceCategory';
import SalonCard from '../../components/ui/SalonCard';
import { 
  ChevronRightIcon, 
  SearchIcon, 
  MapPinIcon, 
  BellIcon 
} from '../../components/common/Icons';

const Home = () => {
  const { navigateTo } = useApp();
  // We'll keep the state variables but won't use them in this simplified version
  // You can safely remove these if you're not using the HomeHeader component
  const [searchValue, setSearchValue] = useState('');

  // Sample salon data (normally would be fetched from an API)
  const salonData = [
    {
      id: 1,
      name: "BARBERIA FOCȘANI",
      rating: 4.98,
      reviews: 484,
      address: "Strada Arhitect Ion Mincu, nr 10, bl. 10, sc. 1, Focșani",
      image: "/api/placeholder/100/100",
      distance: "1.4km"
    },
    {
      id: 2,
      name: "Frizerie cu Stil și Coafor Focșani",
      rating: 4.97,
      reviews: 430,
      address: "Bulevardul Brăilei nr 102 (Parcare Kaufland)",
      image: "/api/placeholder/100/100",
      distance: "2.1km"
    },
    {
      id: 3,
      name: "Black Arrogance",
      rating: 4.76,
      reviews: 70,
      address: "Strada Anghel Saligny nr 11, Liești",
      image: "/api/placeholder/100/100",
      distance: "30km"
    }
  ];

  // Sample service categories
  const serviceCategories = [
    { id: 1, title: "Coafor și hairstyling", image: "/api/placeholder/180/120", category: "hairstyling" },
    { id: 2, title: "Frizerie și barber shop", image: "/api/placeholder/180/120", category: "barbershop" },
    { id: 3, title: "Unghii cu gel - Nails", image: "/api/placeholder/180/120", category: "nails" },
    { id: 4, title: "Cosmetică", image: "/api/placeholder/180/120", category: "cosmetics" },
    { id: 5, title: "Extensii gene - Lashes", image: "/api/placeholder/180/120", category: "lashes" },
    { id: 6, title: "Epilare definitivă", image: "/api/placeholder/180/120", category: "hair-removal" }
  ];

  // Funcția pentru a deschide ecranul de căutare
  const handleSearchClick = () => {
    navigateTo('searchScreen');
  };

  return (
    <div className="flex-1 overflow-y-auto pb-16">
      <header className="p-4 bg-white">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-3xl font-bold text-blue-600">SALON</h1>
          <button 
            className="relative"
            onClick={() => navigateTo('notifications')}
          >
            <BellIcon size={24} />
            <div className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
              3
            </div>
          </button>
        </div>
        <div 
          className="flex bg-gray-100 rounded-md p-2 items-center"
          onClick={handleSearchClick}
        >
          <SearchIcon size={20} className="text-gray-500 ml-2 mr-2" />
          <span className="text-gray-500 flex-1">Caută serviciu, salon</span>
          <div className="flex items-center bg-white rounded-md px-3 py-1 ml-2 text-blue-600">
            <MapPinIcon size={16} className="mr-1" />
            <span className="text-sm">Locația ta</span>
          </div>
        </div>
      </header>

      <section className="p-4">
        <h2 className="text-xl font-bold mb-4">Programează-te online</h2>
        <div className="grid grid-cols-2 gap-4">
          {serviceCategories.map(category => (
            <ServiceCategory 
              key={category.id}
              image={category.image} 
              title={category.title} 
              onClick={() => navigateTo('search', { category: category.category })}
            />
          ))}
        </div>
      </section>

      <section className="p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Recomandate pentru tine</h2>
          <span className="text-blue-600 text-sm">Vezi toate</span>
        </div>
        <div className="space-y-4">
          {salonData.map(salon => (
            <SalonCard 
              key={salon.id}
              salon={salon}
              onClick={() => navigateTo('salon', { salon })}
            />
          ))}
        </div>
      </section>

      <section className="p-4 bg-blue-600 text-white rounded-lg mx-4 mb-4">
      <h3 className="text-xl font-bold mb-2">Nu găsești salonul sau specialistul preferat?</h3>
      <p className="text-sm mb-4">Invită-l să se alăture platformei și bucură-te de programări rapide și simple, direct din aplicație.</p>
      <button className="bg-white text-blue-600 py-2 px-4 rounded-full font-medium">Invită-ți specialistul preferat</button>
    </section>
    </div>
  );
};

export default Home;